import { render } from "./ModalAddUser.vue?vue&type=template&id=5ba4147e&scoped=true"
import script from "./ModalAddUser.vue?vue&type=script&lang=js"
export * from "./ModalAddUser.vue?vue&type=script&lang=js"

import "./ModalAddUser.vue?vue&type=style&index=0&id=5ba4147e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba4147e"]])

export default __exports__